import moment from 'moment';
import { getInMinutes, getformatedTime } from './scheduler-helper';
import { O } from '@angular/cdk/keycodes';

/*
  Helper utilities for handling technician breaks in the scheduler.
  Exports:
    - schedulerConstValue: constants for break actions
    - checkInBreakRange: determines whether an event falls into/removed-from breaks
    - breaksFallBetweenEvent: collects breaks fully inside an event range
    - fallsBetweenBreaks: checks breaks that fall fully inside an event and returns results with provided action
*/

export const schedulerConstValue = {
  DROP_TO_BREAK: 'droppedToBreak',
  REMOVE_FROM_BREAK: 'removeFromBreak',
  NODROP_OR_REMOVE_FROM_BREAK: 'NoDropOrRemoveBreak',
};

export function checkInBreakRange(ev: any, original: any, newTechnicianData: any, origionalTechnicianData: any) {
  // Determine whether the moved event intersects technician break windows.
  // Returns an array of objects describing break-related changes:
  //   { break: 1|-1, value: string, mins: number, breakStartTime: string, breakEndTime: string }
  let startTime = ev.start_date;
  let endTime = ev.end_date;
  let originalStartTime = original.start_date;
  let originalEndTime = original.end_date;
  let inRange = [];
  let newStartRangeTime = startTime.toLocaleTimeString('it-IT');
  let newEndRangeTime = endTime.toLocaleTimeString('it-IT');
  let originalEndRangeTime = originalEndTime.toLocaleTimeString('it-IT');
  let originalStartRangeTime = originalStartTime.toLocaleTimeString('it-IT');

  let break1Mins = getInMinutes(newTechnicianData?.break1EndTime) - getInMinutes(newTechnicianData?.break1StartTime);
  let break2Mins = getInMinutes(newTechnicianData?.break2EndTime) - getInMinutes(newTechnicianData?.break2StartTime);
  let break3Mins = getInMinutes(newTechnicianData?.break3EndTime) - getInMinutes(newTechnicianData?.break3StartTime);
  let technicanDataList = [];
  let timestamps = [];
  timestamps[0] = newStartRangeTime;
  timestamps[1] = newEndRangeTime;
  timestamps[4] = originalStartRangeTime;
  timestamps[5] = originalEndRangeTime;
  // build four item array if endDate is in next day
  if (newStartRangeTime > newEndRangeTime) {
    timestamps[1] = '24:00:00';
    timestamps[2] = '00:00:00';
    timestamps[3] = newEndRangeTime;
  }

  if (newTechnicianData?.resourceID !== origionalTechnicianData?.resourceID) {
    technicanDataList = [origionalTechnicianData, newTechnicianData];
  } else {
    technicanDataList = [newTechnicianData];
  }

  if (technicanDataList.length === 1) {
    for (let t = 0; t < technicanDataList.length; t++) {
      let break1StartTime = getformatedTime((technicanDataList[t]?.break1StartTime > 0 ? technicanDataList[t]?.break1StartTime + 100 : 0).toString());
      let break1EndTime = getformatedTime((technicanDataList[t]?.break1EndTime > 0 ? technicanDataList[t]?.break1EndTime - 100 : 0).toString());
      let break2StartTime = getformatedTime((technicanDataList[t]?.break2StartTime > 0 ? technicanDataList[t]?.break2StartTime + 100 : 0).toString());
      let break2EndTime = getformatedTime((technicanDataList[t]?.break2EndTime > 0 ? technicanDataList[t]?.break2EndTime - 100 : 0).toString());
      let break3StartTime = getformatedTime((technicanDataList[t]?.break3StartTime > 0 ? technicanDataList[t]?.break3StartTime + 100 : 0).toString());
      let break3EndTime = getformatedTime((technicanDataList[t]?.break3EndTime > 0 ? technicanDataList[t]?.break3EndTime - 100 : 0).toString());

      if (break1StartTime && break1EndTime) {
        if (
          (originalEndRangeTime < break1StartTime || originalStartRangeTime > break1EndTime) &&
          ((newStartRangeTime < break1EndTime && newEndRangeTime > break1StartTime && newEndRangeTime < break1EndTime) ||
            (newStartRangeTime > break1StartTime && newStartRangeTime < break1EndTime && newEndRangeTime > break1EndTime) ||
            (newStartRangeTime < break1StartTime && newEndRangeTime > break1EndTime))
        ) {
          inRange.push({
            break: 1,
            value: schedulerConstValue.DROP_TO_BREAK,
            mins: break1Mins,
            breakStartTime: getformatedTime(newTechnicianData?.break1StartTime.toString()),
            breakEndTime: getformatedTime(newTechnicianData?.break1EndTime.toString()),
          });
        } else if (
          originalStartRangeTime < break1StartTime &&
          originalEndRangeTime > break1EndTime &&
          (newEndRangeTime < break1StartTime || newStartRangeTime > break1EndTime)
        ) {
          inRange.push({
            break: -1,
            value: schedulerConstValue.REMOVE_FROM_BREAK,
            mins: break1Mins,
            breakStartTime: getformatedTime(newTechnicianData?.break1StartTime.toString()),
            breakEndTime: getformatedTime(newTechnicianData?.break1EndTime.toString()),
          });
        } else if (
          (originalStartRangeTime < break1StartTime &&
            originalEndRangeTime > break1EndTime &&
            ((newEndRangeTime > break1StartTime && newEndRangeTime < break1EndTime) ||
              (newStartRangeTime > break1StartTime && newStartRangeTime < break1EndTime))) ||
          (newStartRangeTime < break1StartTime && newEndRangeTime > break1EndTime)
        ) {
          inRange.push({
            break: 1,
            value: schedulerConstValue.NODROP_OR_REMOVE_FROM_BREAK,
            mins: break1Mins,
            breakStartTime: getformatedTime(newTechnicianData?.break1StartTime.toString()),
            breakEndTime: getformatedTime(newTechnicianData?.break1EndTime.toString()),
          });
        }
      }
      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      if (break2StartTime && break2EndTime) {
        if (
          (originalEndRangeTime < break2StartTime || originalStartRangeTime > break2EndTime) &&
          ((newStartRangeTime < break2EndTime && newEndRangeTime > break2StartTime && newEndRangeTime < break2EndTime) ||
            (newStartRangeTime > break2StartTime && newStartRangeTime < break2EndTime && newEndRangeTime > break2EndTime) ||
            (newStartRangeTime < break2StartTime && newEndRangeTime > break2EndTime))
        ) {
          inRange.push({
            break: 1,
            value: schedulerConstValue.DROP_TO_BREAK,
            mins: break2Mins,
            breakStartTime: getformatedTime(newTechnicianData?.break2StartTime.toString()),
            breakEndTime: getformatedTime(newTechnicianData?.break2EndTime.toString()),
          });
        } else if (
          originalStartRangeTime < break2StartTime &&
          originalEndRangeTime > break2EndTime &&
          (newEndRangeTime < break2StartTime || newStartRangeTime > break2EndTime)
        ) {
          inRange.push({
            break: -1,
            value: schedulerConstValue.REMOVE_FROM_BREAK,
            mins: break2Mins,
            breakStartTime: getformatedTime(newTechnicianData?.break2StartTime.toString()),
            breakEndTime: getformatedTime(newTechnicianData?.break2EndTime.toString()),
          });
        } else if (
          (originalStartRangeTime < break2StartTime &&
            originalEndRangeTime > break2EndTime &&
            ((newEndRangeTime > break2StartTime && newEndRangeTime < break2EndTime) ||
              (newStartRangeTime > break2StartTime && newStartRangeTime < break2EndTime))) ||
          (newStartRangeTime < break2StartTime && newEndRangeTime > break2EndTime)
        ) {
          inRange.push({
            break: 1,
            value: schedulerConstValue.NODROP_OR_REMOVE_FROM_BREAK,
            mins: break2Mins,
            breakStartTime: getformatedTime(newTechnicianData?.break2StartTime.toString()),
            breakEndTime: getformatedTime(newTechnicianData?.break2EndTime.toString()),
          });
        }
      }

      ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
      if (break3StartTime && break3EndTime) {
        if (
          (originalEndRangeTime < break3StartTime || originalStartRangeTime > break3EndTime) &&
          ((newStartRangeTime < break3EndTime && newEndRangeTime > break3StartTime && newEndRangeTime < break3EndTime) ||
            (newStartRangeTime > break3StartTime && newStartRangeTime < break3EndTime && newEndRangeTime > break3EndTime) ||
            (newStartRangeTime < break3StartTime && newEndRangeTime > break3EndTime))
        ) {
          inRange.push({
            break: 1,
            value: schedulerConstValue.DROP_TO_BREAK,
            mins: break3Mins,
            breakStartTime: getformatedTime(newTechnicianData?.break3StartTime.toString()),
            breakEndTime: getformatedTime(newTechnicianData?.break3EndTime.toString()),
          });
        } else if (
          originalStartRangeTime < break3StartTime &&
          originalEndRangeTime > break3EndTime &&
          (newEndRangeTime < break3StartTime || newStartRangeTime > break3EndTime)
        ) {
          inRange.push({
            break: -1,
            value: schedulerConstValue.REMOVE_FROM_BREAK,
            mins: break3Mins,
            breakStartTime: getformatedTime(newTechnicianData?.break3StartTime.toString()),
            breakEndTime: getformatedTime(newTechnicianData?.break3EndTime.toString()),
          });
        } else if (
          (originalStartRangeTime < break3StartTime &&
            originalEndRangeTime > break3EndTime &&
            ((newEndRangeTime > break3StartTime && newEndRangeTime < break3EndTime) ||
              (newStartRangeTime > break3StartTime && newStartRangeTime < break3EndTime))) ||
          (newStartRangeTime < break3StartTime && newEndRangeTime > break3EndTime)
        ) {
          inRange.push({
            break: 1,
            value: schedulerConstValue.NODROP_OR_REMOVE_FROM_BREAK,
            mins: break3Mins,
            breakStartTime: getformatedTime(newTechnicianData?.break3StartTime.toString()),
            breakEndTime: getformatedTime(newTechnicianData?.break3EndTime.toString()),
          });
        }
      }
    }
  }

  if (technicanDataList.length > 1) {
    // When changing technician, check breaks for both original and new technician
    let getBreakValue = fallsBetweenBreaks(ev, newTechnicianData, schedulerConstValue.DROP_TO_BREAK);
    let getOriginalBreakValue = fallsBetweenBreaks(original, origionalTechnicianData, schedulerConstValue.REMOVE_FROM_BREAK);
    inRange = inRange.concat(getBreakValue);

    if (getBreakValue.length || (getOriginalBreakValue.length && getOriginalBreakValue[0].break < 1)) {
      inRange = inRange.concat(getOriginalBreakValue);
    }
  }

  return inRange;
}

export function breaksFallBetweenEvent(ev: any, newTechnicianData: any) {
  // Collect breaks that are fully contained within the given event range.
  const results: any[] = [];

  const toHHMMNumber = (d: Date) => parseInt(moment(d).format('HHmm'), 10);
  const eventStartMin = getInMinutes(toHHMMNumber(ev.start_date));
  const eventEndMin = getInMinutes(toHHMMNumber(ev.end_date));

  // Return true if [rangeStart..rangeEnd] is fully inside the event range.
  // Handles events that wrap past midnight.
  const isRangeInside = (rangeStartMin: number, rangeEndMin: number, evStartMin: number, evEndMin: number) => {
    if (evStartMin <= evEndMin) {
      return rangeStartMin >= evStartMin && rangeEndMin <= evEndMin;
    }
    // Event wraps past midnight: check either late or early segment.
    const inLatePart = rangeStartMin >= evStartMin && rangeEndMin <= 24 * 60;
    const inEarlyPart = rangeStartMin >= 0 && rangeEndMin <= evEndMin;
    return inLatePart || inEarlyPart;
  };

  const pushForBreak = (breakNum: 1 | 2 | 3, breakStartRaw: any, breakEndRaw: any) => {
    if (!breakStartRaw || !breakEndRaw) return;
    const breakStartMin = getInMinutes(breakStartRaw);
    const breakEndMin = getInMinutes(breakEndRaw);
    const breakMins = breakEndMin - breakStartMin;

    const falls = isRangeInside(breakStartMin, breakEndMin, eventStartMin, eventEndMin);

    results.push({
      break: 1,
      value: schedulerConstValue,
      mins: breakMins,
      breakStartTime: getformatedTime(breakStartRaw.toString()),
      breakEndTime: getformatedTime(breakEndRaw.toString()),
    });
  };

  pushForBreak(1, newTechnicianData?.break1StartTime, newTechnicianData?.break1EndTime);
  pushForBreak(2, newTechnicianData?.break2StartTime, newTechnicianData?.break2EndTime);
  pushForBreak(3, newTechnicianData?.break3StartTime, newTechnicianData?.break3EndTime);

  return results;
}

export function fallsBetweenBreaks(ev: any, newTechnicianData: any, schedulerConst: string) {
  // Check each break and add a result if the break is fully inside the event.
  const results: any[] = [];

  const toHHMMNumber = (d: Date) => parseInt(moment(d).format('HHmm'), 10);
  const eventStartMin = getInMinutes(toHHMMNumber(ev.start_date));
  const eventEndMin = getInMinutes(toHHMMNumber(ev.end_date));

  const isRangeInside = (rangeStartMin: number, rangeEndMin: number, evStartMin: number, evEndMin: number) => {
    if (evStartMin <= evEndMin) {
      return rangeStartMin >= evStartMin && rangeEndMin <= evEndMin;
    }
    const inLatePart = rangeStartMin >= evStartMin && rangeEndMin <= 24 * 60;
    const inEarlyPart = rangeStartMin >= 0 && rangeEndMin <= evEndMin;
    return inLatePart || inEarlyPart;
  };

  const checkBreak = (breakStartRaw: any, breakEndRaw: any) => {
    if (!breakStartRaw || !breakEndRaw) return false;
    const breakStartMin = getInMinutes(breakStartRaw);
    const breakEndMin = getInMinutes(breakEndRaw);
    const breakMins = breakEndMin - breakStartMin;

    const falls = isRangeInside(breakStartMin, breakEndMin, eventStartMin, eventEndMin);
    if (falls) {
      results.push({
        break: schedulerConst === schedulerConstValue.DROP_TO_BREAK ? 1 : -1,
        value: schedulerConst,
        mins: breakMins,
        breakStartTime: getformatedTime(breakStartRaw.toString()),
        breakEndTime: getformatedTime(breakEndRaw.toString()),
      });
    }
  };

  checkBreak(newTechnicianData?.break1StartTime, newTechnicianData?.break1EndTime);
  checkBreak(newTechnicianData?.break2StartTime, newTechnicianData?.break2EndTime);
  checkBreak(newTechnicianData?.break3StartTime, newTechnicianData?.break3EndTime);

  return results;
}

